import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Search } from 'semantic-ui-react';
import { BlogPostPropType } from '../../../../services/proptypes';
import './BlogSearch.css';
var BlogSearch = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BlogSearch, _React$PureComponent);
  var _super = _createSuper(BlogSearch);
  function BlogSearch() {
    _classCallCheck(this, BlogSearch);
    return _super.apply(this, arguments);
  }
  _createClass(BlogSearch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        onResultSelect = _this$props.onResultSelect,
        onSearchChange = _this$props.onSearchChange,
        searchResults = _this$props.searchResults,
        loading = _this$props.loading;
      return /*#__PURE__*/React.createElement("div", {
        className: "blog-search"
      }, /*#__PURE__*/React.createElement(Search, {
        value: value,
        loading: loading,
        onResultSelect: onResultSelect,
        onSearchChange: onSearchChange,
        results: searchResults.map(function (_ref) {
          var title = _ref.title,
            slug = _ref.slug;
          return {
            title: title,
            slug: slug
          };
        }),
        placeholder: "Search Blog",
        minCharacters: 3,
        showNoResults: false
      }));
    }
  }]);
  return BlogSearch;
}(React.PureComponent);
export { BlogSearch as default };
BlogSearch.defaultProps = {
  value: '',
  searchResults: [],
  loading: false
};